// extracted by mini-css-extract-plugin
export default {"counter":"PetsCounter_counter__prKXP","complete":"PetsCounter_complete__-8jH8","checkmark":"PetsCounter_checkmark__TV1wx"};